import { api } from '@/global/services/api'
import { isObject } from '@/global/utils/utils'
import { dateService, FORMATS } from '@/global/services/date'
import documentsHistoryHelper from '../documents-history-helper'
import { notify } from '@/global/services/notification/notificationBus'
import tabsHelper from '../tabs-helper'

const DOCUMENTS_HISTORY_DATA_KEY = 'decisionsDocuments'
const DOCUMENT_TYPE = 'decision'
export default {

  mixins: [
    documentsHistoryHelper,
    tabsHelper
  ],

  data () {
    return {
      decisionsHistoryVisible: false,
      decisionsShowEditButtons: false,
      decisionsEditState: false,
      decisionsShowDocumentPreview: false,
      decisionsDocument: null,
      decisionsDataForGenerationVisible: true,
      decisionsTitle: this.$t('road-maintenance/aggregator.decisions'),
      decisionsBaseTitle: this.$t('road-maintenance/aggregator.decisions'),
      decisionsValidationErrors: {},
      decisionsDocumentHistoryLoaded: false,
      decisionsRefreshDisabled: false,
      decisionsDocumentLoaders: [],
      showDecisionsTabLoader: null
    }
  },

  computed: {
    decisionsConfig () {
      return {
        title: this.$t('road-maintenance/aggregator.decisions'),
        visible: this.$route.query.category !== 'request_new',
        key: 'decisions',
        validationErrors: this.decisionsValidationErrors,
        apiConfig: {
          post: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/${DOCUMENT_TYPE}/store`,
            usePatch: false,
            method: 'post'
          },
          get: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/${DOCUMENT_TYPE}`,
            method: 'get'
          }
        },
        edit: this.decisionsEditState,
        editUpdate: (event) => this.onDecisionsEditUpdate(event),
        dataFetched: (event) => this.onDecisionsDataFetched(event),
        afterCancel: (event) => this.onDecisionsDataFetched(event),
        afterSave: (event) => this.onDecisionsDataFetched(event, true),
        modifyDataBeforeSend: (event) => this.onDecisionsModifyData(event),
        showLoader: this.showDecisionsTabLoader,
        hiddenFormKeys: [
          'html'
        ],
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.decisionsTitle,
            showBackButton: {
              onGoBack: () => this.goBack()
            },
            showEditButtons: this.decisionsShowEditButtons,
            forceAdditionalButtonsDisplay: true,
            additional_buttons: [
              {
                type: 'base',
                appendIcon: 'mdi-refresh',
                visible: !this.decisionsShowEditButtons,
                disabled: this.decisionsRefreshDisabled,
                click: async (event) => {
                  const { fetchTabData } = event || {}
                  this.decisionsRefreshDisabled = true

                  await fetchTabData?.()
                  await this.fetchHistoryDocuments(DOCUMENT_TYPE, DOCUMENTS_HISTORY_DATA_KEY)

                  setTimeout(() => {
                    this.decisionsRefreshDisabled = false
                  }, this.refreshTabBtnTimeout)
                }
              },
              {
                type: 'base',
                label: this.$t('fleet/documents/prl_cargo.change_status'),
                prependIcon: 'mdi-swap-horizontal',
                visible: !this.decisionsShowEditButtons && !!this.permissions?.canChangeStatus,
                click: (event) => this.onChangeStatus(event)
              },
              {
                type: 'dropdown',
                buttonType: 'base',
                label: this.$t('road-maintenance/aggregator.generate_document'),
                color: '#65AD45',
                class: 'generate-document-btn',
                visible: !this.decisionsShowEditButtons && !!this.permissions?.canCreate,
                menuContentClass: 'menu-class',
                component: this.documentsGenerationDropdownMenuComponent,
                hasHistoryData: this.logsData?.[DOCUMENTS_HISTORY_DATA_KEY]?.length,
                menuItemClick: (event) => this.decisionsMenuItemClick(event)
              },
              {
                type: 'base',
                label: this.viewPdfBtnLabel,
                color: '#6e736d',
                visible: this.decisionsShowEditButtons,
                class: 'generate-document-btn',
                loaderConfig: {
                  opacity: 0,
                  color: '#FFFFFFF'
                },
                showLoader: this.showPreviewLoader,
                click: (event) => this.previewDocument(event, DOCUMENT_TYPE, this.decisionsBaseTitle)
              }
            ],
            onCancelTabSave: () => this.onDecisionsCancelTab(),
            onSaveClick: (event) => this.onDecisionsSave(event)
          },
          // Data for document generation
          {
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.data_for_document_generation'),
            visible: this.decisionsDataForGenerationVisible,
            rows: [
              {
                type: 'fields',
                columnsCount: 3,
                fields: [
                  {
                    key: 'doc_class',
                    label: this.$t('road-maintenance/aggregator.class'),
                    row: 1,
                    column: 1,
                    colSpan: 1,
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'registry_number',
                    row: 1,
                    column: 2,
                    colSpan: 1,
                    label: this.$t('road-maintenance/excavation-service/tabs/approval/columns.registration_number'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'created_at',
                    type: 'datetime-picker',
                    subType: 'date',
                    row: 1,
                    column: 3,
                    colSpan: 1,
                    appendIcon: 'mdi-calendar',
                    format: FORMATS.date,
                    placeholder: FORMATS.date,
                    label: this.$t('road-maintenance/aggregator.document_date'),
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.date, true)) {
                        updateValidationErrors({
                          created_at: this.$t('base.invalid_date').replace(':format', FORMATS.date)
                        })
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true,
                    unlock: !!this.permissions?.canCreate,
                    doubleClickEdit: false
                  },
                  {
                    key: 'applicant',
                    row: 2,
                    column: 1,
                    colSpan: 1,
                    label: this.$t('road-maintenance/prp.request_applicant'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'addresses',
                    row: 2,
                    column: 2,
                    colSpan: 2,
                    label: this.$t('road-maintenance/aggregator.request_locations'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'work_type',
                    type: 'textarea',
                    row: 3,
                    column: 1,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.type_of_works_or_actions'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'regulation_setter',
                    row: 3,
                    column: 2,
                    colSpan: 1,
                    label: this.$t('road-maintenance/codebook_type.regulation_setter'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'contractor_name',
                    row: 3,
                    column: 3,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.contractor_name'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'contractor_responsible',
                    row: 4,
                    column: 1,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.contractor_responsible_person'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'contractor_phone',
                    row: 4,
                    column: 2,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.contractor_phone'),
                    creatable: true,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'contractor_email',
                    row: 4,
                    column: 3,
                    colSpan: 1,
                    label: this.$t('road-maintenance/aggregator.contractor_email'),
                    creatable: true,
                    editable: false,
                    visible: true
                  },
                  {
                    type: 'plain-text',
                    text: this.$t('road-maintenance/aggregator.road_closure_will_be_closed'),
                    row: 5,
                    column: 1,
                    colSpan: 1.5,
                    class: 'time-period-text',
                    colClass: 'time-period-column',
                    visible: true
                  },
                  {
                    type: 'plain-text',
                    text: this.$t('road-maintenance/aggregator.requested_date_from_request'),
                    row: 5,
                    column: 2,
                    colSpan: 1.5,
                    class: 'time-period-text',
                    colClass: 'time-period-column',
                    visible: true
                  },
                  {
                    key: 'valid_from',
                    type: 'datetime-picker',
                    row: 6,
                    column: 1,
                    colSpan: 0.75,
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.datetimeShort,
                    placeholder: FORMATS.datetimeShort,
                    label: this.$t('road-maintenance/aggregator.date_from'),
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.datetimeShort, true)) {
                        updateValidationErrors({
                          valid_from: this.$t('base.invalid_date').replace(':format', FORMATS.datetimeShort)
                        })
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true,
                    unlock: !!this.permissions?.canCreate,
                    doubleClickEdit: false
                  },
                  {
                    key: 'valid_to',
                    type: 'datetime-picker',
                    row: 6,
                    column: 1,
                    colSpan: 0.75,
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.datetimeShort,
                    placeholder: FORMATS.datetimeShort,
                    label: this.$t('road-maintenance/aggregator.date_to'),
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.datetimeShort, true)) {
                        updateValidationErrors({
                          valid_to: this.$t('base.invalid_date').replace(':format', FORMATS.datetimeShort)
                        })
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true,
                    unlock: !!this.permissions?.canCreate,
                    doubleClickEdit: false
                  },
                  {
                    key: 'date_time_from',
                    row: 6,
                    column: 2,
                    colSpan: 0.75,
                    appendIcon: 'mdi-calendar-month',
                    label: this.$t('road-maintenance/aggregator.date_from'),
                    onInput: (value, event) => {
                      const { updateData, formData } = event || {}
                      if (value && typeof updateData === 'function' && !formData.valid_from) {
                        updateData({
                          valid_from: value
                        })
                      }
                    },
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'date_time_to',
                    row: 6,
                    column: 2,
                    colSpan: 0.75,
                    appendIcon: 'mdi-calendar-month',
                    label: this.$t('road-maintenance/aggregator.date_to'),
                    onInput: (value, event) => {
                      const { updateData, formData } = event || {}
                      if (value && typeof updateData === 'function' && !formData.valid_to) {
                        updateData({
                          valid_to: value
                        })
                      }
                    },
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'detour',
                    type: 'textarea',
                    row: 7,
                    column: 1,
                    colSpan: 1.5,
                    label: this.$t('road-maintenance/aggregator.detours_during_works'),
                    unlock: !!this.permissions?.canCreate,
                    doubleClickEdit: false,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'amendments',
                    type: 'textarea',
                    row: 7,
                    column: 2,
                    colSpan: 1.5,
                    label: this.$t('road-maintenance/aggregator.necessary_amendments_to_decision'),
                    unlock: !!this.permissions?.canCreate,
                    doubleClickEdit: false,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'document_delivery_participants',
                    type: 'textarea',
                    row: 8,
                    column: 1,
                    colSpan: 3,
                    label: this.$t('road-maintenance/aggregator.other_participants_for_document'),
                    unlock: !!this.permissions?.canCreate,
                    doubleClickEdit: false,
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          // Document history
          {
            component: this.rowBlocksDataComponent,
            mainClasses: 'aggregator-requests-blocks-main',
            wrapperClasses: 'aggregator-requests-subject-wrapper',
            title: this.$t('road-maintenance/aggregator.log_history'),
            visible: this.decisionsHistoryVisible,
            externalData: this.logsData,
            dataKey: DOCUMENTS_HISTORY_DATA_KEY,
            columnsConfig: [
              {
                key: 'created_at',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance.date') + ':',
                customValue: (data) => {
                  return data?.created_at ? dateService.formatCustom(data.created_at, FORMATS.isoDatetime, FORMATS.datetimeShort) : ''
                }
              },
              {
                key: 'status',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance/excavation-service.status') + ':',
                customValue: (data) => {
                  return data?.status ? this.$t(data.status) : '-'
                }
              },
              {
                key: 'user',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance.user') + ':'
              },
              {
                key: 'document',
                valueClass: 'history-block-value',
                visible: (event) => {
                  return event?.blockValue !== '-'
                },
                loaderIds: this.decisionsDocumentLoaders,
                title: this.$t('road-maintenance/aggregator.document') + ':',
                prependImage: {
                  src: '/img/icons/pdf-icon.svg',
                  style: {
                    marginRight: '4%'
                  }
                },
                contentWrapperStyle: {
                  display: 'flex',
                  alignItems: 'center'
                },
                customValue: (data) => {
                  return data?.document?.name ? data.document.name : '-'
                },
                click: (event) => this.onDecisionsDownloadDocument(event)
              },
              {
                visible: (event) => {
                  return !!event?.rowData?.document_data_id
                },
                component: this.createFromVersionBtnComponent,
                class: 'create-from-version-btn-block',
                onClick: (event) => this.onDecisionsCreateFromVersion(event)
              }
            ]
          },
          {
            component: this.documentPreviewComponent,
            visible: this.decisionsShowDocumentPreview,
            content: this.decisionsDocument
          }
        ]
      }
    }
  },

  methods: {
    async onDecisionsDownloadDocument (event) {
      const { id: documentId } = event?.rowData || {}
      // skip if download is already in progress
      if (this.decisionsDocumentLoaders.includes(documentId)) {
        return
      }
      // show document loader
      if (documentId && !this.decisionsDocumentLoaders.includes(documentId)) {
        this.decisionsDocumentLoaders.push(documentId)
      }

      // download document
      await this.downloadDocument(event)
      // stop document loader
      if (this.decisionsDocumentLoaders.includes(documentId)) {
        this.decisionsDocumentLoaders = this.decisionsDocumentLoaders.filter(activeLoaderId => activeLoaderId !== documentId)
      }
    },

    async onDecisionsGenerateDocument (event, showLast = false) {
      try {
        const { formData } = event || {}
        const { id } = this?.$route?.params || {}
        this.showDecisionsTabLoader = true

        // validate data
        if (!id) {
          notify(this.$t('road-maintenance/aggregator.generate_document_not_possible'))
          console.error('Missing traffic regulation id')
          return
        }
        if (!isObject(formData)) {
          notify(this.$t('road-maintenance/aggregator.generate_document_not_possible'))
          console.error('Form data is invalid', formData)
          return
        }

        const dataToSend = new FormData()
        dataToSend.append('detour', formData?.detour ?? '')
        dataToSend.append('amendments', formData?.amendments ?? '')
        dataToSend.append('document_delivery_participants', formData?.document_delivery_participants ?? '')
        dataToSend.append('created_at', formData?.created_at ? dateService.formatCustom(formData.created_at, FORMATS.date, FORMATS.isoDate) : '')
        dataToSend.append('valid_from', formData?.valid_from ? dateService.formatCustom(formData.valid_from, FORMATS.datetimeShort, FORMATS.isoDatetime) : '')
        dataToSend.append('valid_to', formData?.valid_to ? dateService.formatCustom(formData.valid_to, FORMATS.datetimeShort, FORMATS.isoDatetime) : '')
        dataToSend.append('show_last_version', showLast)

        // Get document html
        const { data } = await api('road-maintenance').post(`traffic-regulation/${id}/${DOCUMENT_TYPE}`, dataToSend)

        this.decisionsDocument = data
        this.decisionsShowDocumentPreview = true
        this.decisionsEditState = true
        this.decisionsShowEditButtons = true
        this.decisionsDataForGenerationVisible = false
        this.decisionsTitle = this.$t('road-maintenance/aggregator.decision_document_overview')
      }
      catch (exception) {
        const { errors } = exception?.response?.data || {}
        this.decisionsValidationErrors = errors && isObject(errors) ? errors : {}
        console.error(exception)
      }
      finally {
        this.showDecisionsTabLoader = false
      }
    },

    async onDecisionsCreateFromVersion (event) {
      try {
        this.showDecisionsTabLoader = true

        // get document data
        const data = await this.createFromVersion(event, DOCUMENT_TYPE)

        const { html, css } = data || {}
        // do not open document if data is invalid
        if (!html && !css) {
          return
        }

        // set document data and open document preview
        this.decisionsDocument = data
        this.decisionsShowDocumentPreview = true
        this.decisionsEditState = true
        this.decisionsShowEditButtons = true
        this.decisionsDataForGenerationVisible = false
        this.decisionsTitle = this.$t('road-maintenance/aggregator.decision_document_overview')
      }
      catch (exception) {
        console.error(exception)
      }
      finally {
        this.showDecisionsTabLoader = false
      }
    },

    onDecisionsCancelTab () {
      this.$set(this.informationDialogConfig, 'title', this.$t('base.warning'))
      this.$set(this.informationDialogConfig, 'positiveButtonText', this.$t('base.confirm'))
      this.$set(this.informationDialogConfig, 'cancelButtonText', this.$t('base.cancel'))
      this.$set(this.informationDialogConfig, 'message', this.$t('fleet/vehicle.data_not_saved_message'))
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', () => this.decisionsCancel())
      this.$set(this.informationDialogConfig, 'showDialog', true)
    },

    decisionsCancel () {
      this.decisionsEditState = false
      this.$set(this.informationDialogConfig, 'showDialog', false)
    },

    onDecisionsSave (event) {
      const { saveTab } = event || {}
      this.$set(this.informationDialogConfig, 'title', this.$t('base.warning'))
      this.$set(this.informationDialogConfig, 'positiveButtonText', this.$t('base.confirm'))
      this.$set(this.informationDialogConfig, 'cancelButtonText', this.$t('base.cancel'))
      this.$set(this.informationDialogConfig, 'message', this.$t('road-maintenance/aggregator.document_will_be_uploaded_to_centrix_message'))
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', () => this.onDecisionsSaveConfirmation(saveTab))
      this.$set(this.informationDialogConfig, 'showDialog', true)
    },

    onDecisionsSaveConfirmation (saveTabFn) {
      if (typeof saveTabFn === 'function') {
        saveTabFn()
      }

      this.decisionsEditState = false
      this.$set(this.informationDialogConfig, 'showDialog', false)
      this.$set(this.informationDialogConfig, 'title', this.informationDialogBaseConfig.title)
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', this.informationDialogBaseConfig.confirmCallbackFunction)
    },

    onDecisionsEditUpdate (event) {
      const { edit } = event || {}
      this.decisionsHistoryVisible = !edit

      if (!edit) {
        this.decisionsShowDocumentPreview = false
        this.decisionsEditState = false
        this.decisionsShowEditButtons = false
        this.decisionsDataForGenerationVisible = true
        this.decisionsDocument = null
        this.decisionsTitle = this.decisionsBaseTitle
      }
    },

    async onDecisionsDataFetched (event, afterSave = false) {
      const { data: apiData, updateData } = event || {}
      const { formDataForSend } = event || {}

      const data = apiData?.data || formDataForSend || {}

      if (typeof updateData === 'function' && data && isObject(data)) {
        updateData({
          // Update contractor
          contractor_name: data?.contractor?.name ?? null,
          contractor_responsible: data?.contractor?.responsible_person ?? null,
          contractor_phone: data?.contractor?.phone ?? null,
          contractor_email: data?.contractor?.email ?? null,
          created_at: data?.created_at && !dateService.isValid(data.created_at, FORMATS.date, true) ? dateService.formatCustom(data.created_at, FORMATS.isoDatetime, FORMATS.date) : dateService.now(FORMATS.date),

          // Regulation setter
          regulation_setter: data?.regulation_setter?.description ? this.$t(data.regulation_setter.description) : null,

          // datetime from and to
          date_time_from: data?.date_time_from ? dateService.formatCustom(data.date_time_from, FORMATS.isoDatetime, FORMATS.datetimeShort) : null,
          date_time_to: data?.date_time_to ? dateService.formatCustom(data.date_time_to, FORMATS.isoDatetime, FORMATS.datetimeShort) : null,
          valid_from: data?.valid_from ? dateService.formatCustom(data.valid_from, FORMATS.isoDatetime, FORMATS.datetimeShort) : null,
          valid_to: data?.valid_to ? dateService.formatCustom(data.valid_to, FORMATS.isoDatetime, FORMATS.datetimeShort) : null
        })
      }

      if (!this.decisionsDocumentHistoryLoaded || afterSave) {
        this.decisionsDocumentHistoryLoaded = true
        const { id: suggestedStatusId, description } = data?.suggested_status || {}

        // Fetch documents logs
        await this.fetchHistoryDocuments(DOCUMENT_TYPE, DOCUMENTS_HISTORY_DATA_KEY)

        // Open change status popup after documents save only if we have suggested status provided
        if (suggestedStatusId) {
          this.$set(this.afterDocumentStatusChangeActions, 'statusId', suggestedStatusId)
          const message = this.$t('road-maintenance/aggregator.status_change_message')
          this.$set(this.informationDialogConfig, 'showDialog', afterSave)
          this.$set(this.informationDialogConfig, 'message', '<div> ' + message + '<span style="font-style: italic; color: green;">' + ' ' + this.$t(description) + '</span>?</div>')
        }
      }
    },

    onDecisionsModifyData (event) {
      const { originalData } = event || {}

      if (originalData) {
        originalData.created_at = originalData?.created_at ? dateService.formatCustom(originalData.created_at, FORMATS.date, FORMATS.isoDate) : null
        originalData.valid_from = originalData?.valid_from ? dateService.formatCustom(originalData.valid_from, FORMATS.datetimeShort, FORMATS.isoDatetime) : null
        originalData.valid_to = originalData?.valid_to ? dateService.formatCustom(originalData.valid_to, FORMATS.datetimeShort, FORMATS.isoDatetime) : null
      }

      return originalData
    },

    async decisionsMenuItemClick (event) {
      const { menuIndex } = event || {}
      await this.onDecisionsGenerateDocument(event, menuIndex === 1)
    }
  }
}
